import { Component, OnInit,Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActiveCampaignService } from 'src/app/Services/ActiveCampaign.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-leavecomment',
  templateUrl: './LeaveComment.component.html',
  styleUrls: ['./LeaveComment.component.scss']
})
export class LeavecommentComponent implements OnInit {
	@Input() txtColorWhite=false;
	@Input() tag='';

	public  form 	: FormGroup;
	emailPattern   : string    = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$";
	name_ac='';
	email_ac='';
	telefone_ac='';
	errorEmail=false;
	errorName=false;
	loading=false;
	sendOk=false;

	constructor(private fb : FormBuilder,private aC: ActiveCampaignService,private router: Router) { }

	ngOnInit() {

		this.form = this.fb.group({  
  			lname  			: ['', Validators.required],
  			email 			: ['', [Validators.required,Validators.pattern(this.emailPattern)]] ,
		});

	}

	validateEmail(email) {
		const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regularExpression.test(String(email).toLowerCase());
	   }


	async  clickInscrever(){
		this.loading=true;
		if (!this.validateEmail(this.email_ac)){
			this.errorEmail=true;
			this.loading=false;

		}else{

			this.loading=true;
			const nameArray = this.name_ac.trim().split(' ');
			if (nameArray.length < 2) {
			  this.loading = false;
			  this.errorName=true;
			  
			} else {
		
			  let firstNames = '';
			  let lastName = '';
			  console.log(nameArray)

			  nameArray.map((name, i) => {
				if (i==0){
					firstNames=name
				}else{
					lastName = lastName.concat(name + ' ');
				}
				// if (i != nameArray.length - 1) {
				//   firstNames = firstNames.concat(name + ' ');
				// } else {
				//   lastName = name;
				// }
			  });
			  console.log(firstNames)
			  console.log(lastName)
			
			  await this.aC.registerContactForm(firstNames,lastName,this.email_ac.toLowerCase(),this.tag,this.telefone_ac);
			  this.name_ac='';
			  this.email_ac='';
			  this.errorEmail=false;
			  this.errorName=false;
      		  this.loading=false;
			  this.router.navigate(['/thank-you-blog-suscription']);
			 // this.sendOk=true;
			  
			//	var that = this;
			//	 setTimeout(function(){
			//		 that.sendOk = false;
			//	 },5000);

			}



			

		}
	  console.log('Inscribir'+this.name_ac);
	  console.log('Inscribir '+this.validateEmail(this.email_ac));

	 // await this.aC.registerContact(firstNames,lastName,this.form.get('email').value);

  }

}
